import { render, staticRenderFns } from "./OfferCustomerDetails.vue?vue&type=template&id=38b98821"
import script from "./OfferCustomerDetails.vue?vue&type=script&lang=js"
export * from "./OfferCustomerDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports